// Données des packs pour le SEO et contenu

export const packsData = [
  {
    id: 'pack-essentiel-mer-rouge',
    name: 'Essentiel Mer Rouge',
    slug: 'pack-essentiel-mer-rouge',
    badge: '⭐ Le plus choisi',
    subtitle: 'Les incontournables d\'Hurghada en toute simplicité',
    image: 'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto,w_1200,h_675,c_fill/v1767543316/orange-bay-hurghada-island_5_lf4q4c.jpg',
    activities: [
      { name: 'Orange Bay' },
      { name: 'Dolphin Day at Sea' }
    ],
    packPrice: 48,
    depositPrice: 10,
    remainingPrice: 38,
    popular: true,
    stripeLink: 'https://buy.stripe.com/dRmeVca6Fg1a4Cb4ZndMI00'
  },
  {
    id: 'pack-aventure-evasion',
    name: 'Aventure & Évasion',
    slug: 'pack-aventure-evasion',
    badge: null,
    subtitle: 'Mer turquoise & moments inoubliables',
    image: 'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto,w_1200,h_675,c_fill/v1767544721/horse-riding-hurghada_1_whlt0w.png',
    activities: [
      { name: 'Orange Bay' },
      { name: 'Balade à cheval' }
    ],
    packPrice: 52,
    depositPrice: 15,
    remainingPrice: 37,
    popular: false,
    stripeLink: 'https://buy.stripe.com/5kQ14mgv3dT26KjgI5dMI01'
  },
  {
    id: 'pack-sejour-signature',
    name: 'Séjour Signature Hurghada',
    slug: 'pack-sejour-signature',
    badge: null,
    subtitle: 'Culture égyptienne & mer Rouge réunies',
    image: 'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto,w_1200,h_675,c_fill/v1767545544/luxor-day-tour-valley-of-the-kings_2_o6wses.png',
    activities: [
      { name: 'Louxor 1 jour' },
      { name: 'Orange Bay' },
      { name: 'Dolphin Day at Sea' }
    ],
    packPrice: 115,
    depositPrice: 20,
    remainingPrice: 95,
    popular: false,
    stripeLink: 'https://buy.stripe.com/14AbJ0baJeX69Wv63rdMI02'
  }
];

export const packsFaq = [
  {
    question: 'Que comprend exactement un pack ?',
    answer: 'Chaque pack inclut plusieurs excursions soigneusement sélectionnées, organisées par des partenaires locaux fiables. Les transferts depuis ton hôtel, l\'encadrement et l\'activité principale sont inclus selon l\'excursion. Les détails précis sont confirmés après la réservation.'
  },
  {
    question: 'Pourquoi réserver un pack plutôt que les activités séparément ?',
    answer: 'Les packs sont pensés pour simplifier ton organisation, optimiser ton séjour et bénéficier d\'un tarif plus avantageux. C\'est la solution idéale si tu restes plusieurs jours à Hurghada.'
  },
  {
    question: 'Comment se déroule le paiement ?',
    answer: 'Tu réserves ton pack avec un acompte de 20% sécurisé via Stripe. Le solde est à régler le jour de l\'excursion, directement auprès du prestataire local. Aucun paiement caché, tout est clair dès le départ.'
  },
  {
    question: 'Puis-je poser des questions avant de réserver ?',
    answer: 'Bien sûr. Je suis ton contact français et je reste disponible sur WhatsApp pour répondre à toutes tes questions avant, pendant et après la réservation.'
  },
  {
    question: 'Les packs conviennent-ils aux familles et aux débutants ?',
    answer: 'Oui. Les excursions proposées dans les packs sont accessibles aux débutants et adaptées aux familles, sauf indication contraire. N\'hésite pas à me préciser l\'âge des participants pour confirmation.'
  },
  {
    question: 'Que se passe-t-il après la réservation du pack ?',
    answer: 'Après ta réservation : je te confirme les disponibilités, je te communique les horaires et le point de prise en charge, et tu reçois toutes les informations pratiques pour profiter sereinement de tes excursions.'
  }
];

// Note: whatsappLink is deprecated, use getGenericWhatsAppLink() from utils/whatsapp.js instead
export const whatsappLink = 'https://wa.me/201221948907?text=Bonjour%2C%20je%20souhaite%20r%C3%A9server%20un%20pack%20d%27excursions%20%C3%A0%20Hurghada';
